import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';
import { auxiliaryMachines } from '../../mock/mockData';

const ShrinkPackaging = () => {
  const productData = auxiliaryMachines.find(p => p.id === 'shrink-packaging');
  return <ProductPageTemplate productData={productData} />;
};

export default ShrinkPackaging;